import React, { type FC, useState } from 'react';
import { Divider } from '@wix/design-system';
import { Route, Routes } from 'react-router-dom';
import './global.scss';
import css from './App.scss';
import { TemplatesMainPageWrapper } from '../MainPage/TemplatesMainPageWrapper';
import { SingleTemplatePageWrapper } from '../TemplatePage/SingleTemplatePageWrapper';
import '@wix/design-system/styles.global.css';
import { OpenBlocksTemplate } from '../OpenBlocksTemplate/OpenBlocksTemplate';
import { APP_PAGES } from '../../constants/routes';
import { AppLoader } from './AppLoader';
import { useHandleFunnelRedirect } from '../../hooks/useHandleFunnelRedirect';

const AppCore: FC = () => {
  const [appLoaded, setAppLoaded] = useState(false);

  useHandleFunnelRedirect(setAppLoaded);

  if (!appLoaded) {
    return <AppLoader />;
  }

  return (
    <>
      <Routes>
        <Route
          path={APP_PAGES.TEMPLATES_MAIN_PAGE}
          element={<TemplatesMainPageWrapper />}
        />
        <Route
          path={APP_PAGES.TEMPLATE_PAGE}
          element={<SingleTemplatePageWrapper />}
        />
        <Route
          path={APP_PAGES.OPEN_BLOCKS_TEMPLATE_ROUTE}
          element={<OpenBlocksTemplate />}
        />
      </Routes>
      <div className={css.dividerBeforeFooter}>
        <Divider />
      </div>
    </>
  );
};

export default AppCore;
